import { Box, Grid } from '@material-ui/core'
import { styled } from '@material-ui/core/styles'

import Image from 'artkive/components/Image'
import { BREAKPOINTS } from 'artkive/utils/constants'

export const Wrapper = styled('div')(({ theme }) => ({
  backgroundColor: theme.colors.white.dark,
}))

export const ProductsContainerWrapper = styled(Box)(({ theme }) => ({
  backgroundColor: theme.colors.white,
  overflowX: 'hidden',
}))

export const GridContainer = styled(Grid)(({ theme }) => ({
  [theme.breakpoints.down(BREAKPOINTS.xl)]: {
    padding: '0 32px',
  },
  [theme.breakpoints.down('sm')]: {
    padding: '0 16px',
  },
}))

export const GridItem = styled(Grid)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  position: 'relative',
  ['&:not(:last-of-type)']: {
    [theme.breakpoints.down('sm')]: {
      paddingBottom: '64px',
    },
  },
}))

export const BubbleIcon = styled(Image)(({ theme }) => ({
  position: 'absolute',
  transform: 'scaleX(-1)',
  top: '170px',
  left: '-35px',
  width: '76px',
  [theme.breakpoints.up('md')]: {
    top: '117px',
    left: '-44px',
    transform: 'none',
  },
  [theme.breakpoints.up('lg')]: {
    top: '160px',
    left: '-48px',
    width: '96px',
  },
  [theme.breakpoints.up(BREAKPOINTS.xl)]: {
    top: '176px',
    left: '-36px',
  },
  [theme.breakpoints.up(BREAKPOINTS.xxl)]: {
    top: '256px',
  },
}))

export const BrushStrokesIcon = styled(Image)(({ theme }) => ({
  position: 'absolute',
  top: '-36px',
  right: '-8px',
  width: '64px',
  transform: 'scaleX(-1)',
  zIndex: 2,
  [theme.breakpoints.up('md')]: {
    top: '-48px',
    right: '-10px',
    width: '74px',
  },
  [theme.breakpoints.up('lg')]: {
    top: '-40px',
    right: '-16px',
  },
  [theme.breakpoints.up(BREAKPOINTS.xl)]: {
    right: '-32px',
  },
}))

export const ProductsContainer = styled('div')(({ theme }) => ({
  margin: '0 auto',
  width: '100%',
  [theme.breakpoints.up(BREAKPOINTS.lg)]: {
    maxWidth: '1280px',
  },
  [theme.breakpoints.up(BREAKPOINTS.xxl)]: {
    maxWidth: '1620px',
  },
}))
